module.exports = __webpack_public_path__ + "static/media/qty.a2c49a8c.svg";